import { isValidProtoDriver } from './validators/functions/is-valid-proto-driver.function';

export * from './dtos/proto-driver-search.dto';
export * from './dtos/proto-driver.dto';

export * from './types/proto-drivers-filters';

export * from './validators/schemas/create-proto-driver.schema';
export * from './validators/schemas/update-proto-driver.schema';

export const protoDriverValidators = {
	isValidProtoDriver,
};
